import React, { useCallback, useState } from 'react';
import { Form } from 'react-bootstrap';
import { ArrowDownOutline, ArrowUpOutline } from 'react-ionicons';

const FileExplorerHeader = ({
    onSortClick,
    onAllFilesChecked,
    isAllFilesChecked,
}) => {
    const [sortBy, setSortBy] = useState('name');
    const [sortOrder, setSortOrder] = useState('ASC');

    const onSortByClick = useCallback(
        (sortName) => {
            let newOrder = 'ASC';

            if (sortBy === sortName) {
                newOrder = sortOrder === 'ASC' ? 'DESC' : 'ASC';
            } else {
                setSortBy(sortName);
            }
            setSortOrder(newOrder);
            onSortClick(sortName, newOrder);
        },
        [onSortClick, sortBy, sortOrder]
    );

    return (
        <thead>
            <tr>
                <th style={{ width: 20 }} className="rounded">
                    <Form.Check
                        onClick={onAllFilesChecked}
                        checked={isAllFilesChecked}
                    />
                </th>
                <th
                    className="rounded"
                    width="40%"
                    onClick={() => onSortByClick('name')}
                >
                    <div className="d-flex align-items-center gap-1">
                        <span>Name</span>
                        {sortBy === 'name' && (
                            <>
                                {sortOrder === 'ASC' ? (
                                    <ArrowDownOutline />
                                ) : (
                                    <ArrowUpOutline />
                                )}
                            </>
                        )}
                    </div>
                </th>
                <th width="15%">Extension</th>
                <th width="15%">Size</th>
                <th width="25%" onClick={() => onSortByClick('lastUpdate')}>
                    <div className="d-flex align-items-center gap-1">
                        <span>Last Update</span>
                        {sortBy === 'lastUpdate' && (
                            <>
                                {sortOrder === 'ASC' ? (
                                    <ArrowDownOutline />
                                ) : (
                                    <ArrowUpOutline />
                                )}
                            </>
                        )}
                    </div>
                </th>
                <th className="rounded" width="5%" />
            </tr>
        </thead>
    );
};

export default FileExplorerHeader;
